module.exports = __webpack_public_path__ + "img/industry-case-wine.776305ca.png";